import { CustomError } from "ts-custom-error";
export class MastoDeserializeError extends CustomError {
    contentType;
    data;
    constructor(message, contentType, data, options) {
        super(message, options);
        this.contentType = contentType;
        this.data = data;
    }
}
